module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('recharge-record-pc', {
    staticClass: "pc-show",
    attrs: {
      "init-data": _vm.initData,
      "hasFetch": _vm.hasFetch
    }
  }), _vm._v(" "), _c('recharge-record-m', {
    staticClass: "phone-show",
    attrs: {
      "init-data": _vm.initData,
      "hasFetch": _vm.hasFetch
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-98f8e4ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rechargeRecord/RechargeRecord.vue
// module id = 1371
// module chunks = 1